import type { TFunction } from "i18next";
import type { AuditEntry } from "@/api/audit";

export interface AuditTarget {
  to: "/projects/$projectId" | "/approvals/$simulationId" | null;
  params: Record<string, string | number>;
}

export function auditTarget(entry: AuditEntry): AuditTarget {
  if (typeof entry.simulation_id === "number") {
    return {
      to: "/approvals/$simulationId",
      params: { simulationId: entry.simulation_id },
    };
  }
  if (typeof entry.project_id === "number") {
    return {
      to: "/projects/$projectId",
      params: { projectId: String(entry.project_id) },
    };
  }
  return { to: null, params: {} };
}

const KNOWN_KINDS = new Set([
  "task_move",
  "task_status_change",
  "apply_template",
  "add_task",
  "remove_task",
  "set_allocation",
  "set_task_overtime",
  "set_company_calendar_override",
  "create_project_from_template",
  "manual_edit",
]);

export function formatAuditSummary(entry: AuditEntry, t: TFunction): string {
  return KNOWN_KINDS.has(entry.kind) ? t(`audit.kind.${entry.kind}`) : entry.kind;
}
